import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type shopGridView = 'four-col' | 'three-col'

type UserState = {
  shopGridView: shopGridView
}

type UserAction = {
  setShopGridView: (view: shopGridView) => void
}

const initialState: UserState = {
  shopGridView: 'three-col',
}

export const useUserStore = create(
  persist<UserAction & UserState>(
    (set) => ({
      ...initialState,
      setShopGridView: (view: shopGridView) => set({ shopGridView: view }),
    }),
    {
      name: 'userLocalStorage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
